import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { FormControlLabel, Paper, Checkbox, Grid, makeStyles } from "@material-ui/core";
import { RadioButtonUnchecked, Adjust } from "@material-ui/icons";
import { useTranslation } from "react-i18next";
import { get, set } from "@totalsoft/react-state-lens";
import { onCheckBoxChange } from "utils/propertyChangeAdapters";
import clientPageStyle from "../styles";

const useStyles = makeStyles(clientPageStyle);

function ColesseeCard({ withColesseeLens, quotePartnersLens }) {
  const { t } = useTranslation();
  const classes = useStyles();
  const handleChange = useCallback(
    (value) => () => {
      (withColesseeLens |> set)(value);
      if (!value) (quotePartnersLens |> set)([]);
      else (quotePartnersLens |> set)([{ roleId: -1 }]);
    },
    [withColesseeLens, quotePartnersLens]
  );

  return (
    <Paper className={classes.filterStyle}>
      <Grid container>
        <Grid item>
          <FormControlLabel
            className={classes.formControlLabel}
            control={
              <Checkbox
                color="primary"
                icon={<RadioButtonUnchecked />}
                checkedIcon={<Adjust />}
                checked={!(withColesseeLens |> get)}
                onChange={handleChange(false) |> onCheckBoxChange}
              />
            }
            label={t("Client.LesseeOnly")}
          />
          <FormControlLabel
            className={classes.formControlLabel}
            control={
              <Checkbox
                color="primary"
                icon={<RadioButtonUnchecked />}
                checkedIcon={<Adjust />}
                checked={withColesseeLens |> get}
                onChange={handleChange(true) |> onCheckBoxChange}
              />
            }
            label={t("Client.WithColessee")}
          />
        </Grid>
      </Grid>
    </Paper>
  );
}

ColesseeCard.propTypes = {
  withColesseeLens: PropTypes.object.isRequired,
  quotePartnersLens: PropTypes.object.isRequired,
};

export default ColesseeCard;
